import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { trafficSourceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addTrafficSource = (
  data: trafficSourceTypes.AddTrafficSourceData
): Promise<{ trafficSource: trafficSourceTypes.TrafficSource }> => {
  return axios.put('/traffic-sources', data);
};

type AddTrafficSourceOptions = {
  onSuccess: () => void;
  config?: MutationConfig<typeof addTrafficSource>;
};

export function useAddTrafficSource({ config = {}, onSuccess }: AddTrafficSourceOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['traffic-sources']);
      toasts.loadingToast.success('add-traffic-source', 'Traffic source added successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-traffic-source', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-traffic-source', 'Adding traffic source...');
      config.onMutate?.(...args);
    },
    mutationFn: addTrafficSource,
  });
}
